import React from 'react';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import {
  FDPrimaryActionButton, FDPrimaryActionIconButton, FDStack,
} from '@facet-wealth/design';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { dataAttrs, testAttr } from 'Helpers/Testing';
import { DialogActions, DialogContent } from 'Views/Page/Content/Modal/Components';
import fr from 'facet-rest';


const Layout = () => {
  const { resource, onSubmit, saving } = useMetaLayoutContext();
  const { clearModalCollection, loadModalCollectionByLink } = useModalContext();
  const { refreshPageContentCollection } = usePageContentContext();

  const handleClose = () => {
    clearModalCollection();
    refreshPageContentCollection();
  };

  const handleSubmit = async () => {
    await onSubmit();
  };

  const handleContinue = async () => {
    if (resource.meta().canPost()) {
      return handleSubmit();
    }
    return handleClose();
  };

  return (
    <>
      <MetaControlField
        attr={'moduleName'}
        {...dataAttrs('risk-tolerance-title', resource, {
          [testAttr.dataType]: resource.attr('type'),
        })}
      />
      <DialogContent scrollKey={resource?.type() + resource?.id()}>
        <FDStack direction="column" spacing={3}>
          <MetaControlField attr={'primaryText'} />
          <MetaControlField attr={'secondaryText'} />
          <MetaControlField attr={'clients'} />
        </FDStack>
      </DialogContent>
      <DialogActions>
        {resource.withRelationship(fr.relationships.previousLink.name,
          (rel) => (
            <FDPrimaryActionIconButton
              icon="chevronLeft"
              onClick={() => {
                loadModalCollectionByLink(rel.link('related').url());
              }}
            />
          ),
          () => null)}
        <FDPrimaryActionButton
          label={'Continue →'}
          loading={saving}
          onClick={handleContinue}
          {...dataAttrs('continue-btn', resource, {
            [testAttr.dataType]: resource.attr('type'),
          })}
        />
      </DialogActions>
    </>
  );
};

export default Layout;
